import React from 'react';
import { format } from 'date-fns';

/**
 * Journey Card Component
 * Displays a journey summary card
 */
const JourneyCard = ({ journey, onDelete, onView }) => {
  const progress = journey.progress?.overall || 0;
  const goalsCount = journey.goals?.length || 0;
  const statusColors = {
    active: 'bg-green-100 text-green-800',
    draft: 'bg-gray-100 text-gray-800',
    completed: 'bg-blue-100 text-blue-800',
    archived: 'bg-yellow-100 text-yellow-800'
  };

  return (
    <div className="bg-white rounded-lg shadow-md hover:shadow-xl transition-shadow duration-200 overflow-hidden">
      <div className="p-6">
        {/* Header */}
        <div className="flex justify-between items-start mb-4">
          <div className="flex-1">
            <h3 className="text-xl font-semibold text-gray-900 mb-1">
              {journey.name}
            </h3>
            <p className="text-sm text-gray-500">
              Created {format(new Date(journey.createdAt), 'MMM d, yyyy')}
            </p>
          </div>
          <span className={`px-2 py-1 text-xs font-semibold rounded-full ${statusColors[journey.status] || statusColors.draft}`}>
            {journey.status}
          </span>
        </div>

        {/* Goals */}
        <div className="mb-4">
          <p className="text-sm text-gray-600 mb-2">
            <span className="font-semibold">{goalsCount}</span> {goalsCount === 1 ? 'Goal' : 'Goals'}
          </p>
          <div className="flex flex-wrap gap-2">
            {journey.goals?.slice(0, 3).map((goal, idx) => (
              <span
                key={idx}
                className="px-2 py-1 bg-indigo-50 text-indigo-700 text-xs rounded-md"
              >
                {goal.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}
              </span>
            ))}
            {goalsCount > 3 && (
              <span className="px-2 py-1 bg-gray-100 text-gray-600 text-xs rounded-md">
                +{goalsCount - 3} more
              </span>
            )}
          </div>
        </div>

        {/* Progress */}
        <div className="mb-4">
          <div className="flex justify-between items-center mb-2">
            <span className="text-sm font-medium text-gray-700">Progress</span>
            <span className="text-sm font-semibold text-indigo-600">{progress}%</span>
          </div>
          <div className="w-full bg-gray-200 rounded-full h-2">
            <div
              className="bg-gradient-to-r from-indigo-500 to-purple-600 h-2 rounded-full transition-all duration-300"
              style={{ width: `${progress}%` }}
            ></div>
          </div>
        </div>

        {/* Actions */}
        <div className="flex space-x-2 mt-6">
          <button
            onClick={onView}
            className="flex-1 px-4 py-2 bg-indigo-600 text-white text-sm font-medium rounded-lg hover:bg-indigo-700 transition-colors"
          >
            View Details
          </button>
          <button
            onClick={() => onDelete(journey._id)}
            className="px-4 py-2 bg-red-100 text-red-700 text-sm font-medium rounded-lg hover:bg-red-200 transition-colors"
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default JourneyCard;

